import { Col, Form, Row, Table } from "antd";

const AssignedUser = ({ assignedUsers = [], loading = false }) => {
    const [form] = Form.useForm();

    const colums = [
        {
            title: "FULL NAME",
            dataIndex: "fullname",
            key: "fullname",
            width: "34%",
            render: (text, record) => `${record.user?.firstName || ''} ${record.user?.lastName || ''}`,
        },
        {
            title: "JOB TITLE",
            dataIndex: "jobTitle",
            key: "jobTitle",
            width: "33%",
            render: (text, record) => record.user?.jobTitle || '',
        },
        {
            title: "EMAIL",
            dataIndex: "email",
            key: "email",
            width: "33%",
            render: (text, record) => record.user?.email || '',
        },
    ]

    return (
        <>
            <Row>
                <Col span={24} className="heading-col">
                    <Row align="middle" justify="space-between">
                        <Col>
                            <div>
                                <span className="heading-span">Assigned Users</span>
                            </div>
                        </Col>
                    </Row>
                </Col>
                <Col
                    span={24}
                    className="user-details-section"
                >
                    <Row justify="center">
                        <Col md={24} lg={23} xl={20} xxl={16}>
                            <Form form={form} component={false}>
                                <Table
                                    locale={{
                                        emptyText: <div style={{ textAlign: "center", padding: "20px" }}>No User Assigned</div>
                                    }}
                                    className="special-table"
                                    columns={colums}
                                    pagination={false}
                                    rowClassName="editable-row"
                                    dataSource={assignedUsers}
                                    loading={loading}
                                >
                                </Table>
                            </Form>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    )
}

export default AssignedUser;
